import {
  GitPullRequestIcon,
  GitPullRequestClosedIcon,
  GitPullRequestDraftIcon,
  GitMergeIcon,
  IssueOpenedIcon,
  CheckCircleIcon,
  type Icon,
  SkipIcon,
} from '@primer/octicons-react'

function issueIsOpen(state: string) {
  return state === 'open'
}

export function getIssueIconColor(
  state: string,
  isPullRequest: boolean,
  merged?: boolean,
  reviewableState?: string,
  state_reason?: string,
) {
  if (isPullRequest) {
    if (reviewableState === 'draft') {
      return 'var(--fgColor-draft)'
    } else if (merged) {
      return 'var(--fgColor-done)'
    } else if (issueIsOpen(state)) {
      return 'var(--fgColor-open)'
    } else {
      return 'var(--fgColor-closed)'
    }
  } else if (issueIsOpen(state)) {
    return 'var(--fgColor-success)'
  } else {
    if (state_reason === 'not_planned' || state_reason === 'duplicate') {
      return 'var(--fgColor-muted)'
    }
    return 'var(--fgColor-done)'
  }
}

export function getIssueIcon(
  state: string,
  isPullRequest: boolean,
  state_reason?: string,
  merged?: boolean,
  reviewableState?: string,
): Icon {
  if (isPullRequest) {
    if (reviewableState === 'draft') {
      return GitPullRequestDraftIcon
    } else if (merged) {
      return GitMergeIcon
    } else if (issueIsOpen(state)) {
      return GitPullRequestIcon
    } else {
      return GitPullRequestClosedIcon
    }
  } else {
    if (issueIsOpen(state)) {
      return IssueOpenedIcon
    } else {
      if (state_reason === 'not_planned' || state_reason === 'duplicate') {
        return SkipIcon
      }
      return CheckCircleIcon
    }
  }
}
